import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CategoriesMenuActions } from '../store/actions';
import { StateWithCategoriesMenu } from '../store/categories-menu-state';
import { CategoriesMenuSelectors } from '../store/selectors';

@Injectable({ providedIn: 'root' })
export class CategoriesMenuRootNodeIdService {
  constructor(private store: Store<StateWithCategoriesMenu>) {}

  loadRootNodeId(): void {
    this.store.dispatch(new CategoriesMenuActions.CategoriesMenuRootNodeIdLoad());
  }

  getRootNodeIdState(): Observable<StateUtils.LoaderState<string>> {
    return this.store.select(CategoriesMenuSelectors.getCategoriesMenuRootNodeIdState);
  }

  getRootNodeId(): Observable<string> {
    return this.store.select(CategoriesMenuSelectors.getCategoriesMenuRootNodeIdValue);
  }

  getRootNodeIdLoading(): Observable<boolean> {
    return this.store.select(CategoriesMenuSelectors.getCategoriesMenuRootNodeIdLoading);
  }

  getRootNodeIdError(): Observable<boolean> {
    return this.store.select(CategoriesMenuSelectors.getCategoriesMenuRootNodeIdError);
  }

  getRootNodeIdSuccess(): Observable<boolean> {
    return this.store.select(CategoriesMenuSelectors.getCategoriesMenuRootNodeIdSuccess);
  }
}
